import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@uncinc/uncinc-react-kitchen-sink';
import {
  commerceCartRemoveProduct,
} from '@uncinc/react-drupal-core/dist/redux/actions/Commerce';
import { useDispatch, useSelector } from 'react-redux';
import './style.scss';
import { findProductWithId, formatCartItemForAnalytics } from '../../../../helpers/commerce';

const RemoveProductModal = ({ showModal, id, setShowModal }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const products = useSelector((state) => state.getIn(['commerce', 'cart', 'products']));
  const escFunction = useCallback((event) => {
    if (event.key === 'Escape') {
      setShowModal(false);
    }
  }, [setShowModal]);

  const handleRemoveFromCart = () => {
    const productToRemove = findProductWithId(id, products);
    dispatch(commerceCartRemoveProduct(id))
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'remove_from_cart',
      ecommerce: {
        currency: 'EUR',
        value: productToRemove.getIn(['attributes', 'total_price', 'number']),
        items: [
          formatCartItemForAnalytics(productToRemove)
        ]
      }
    });
  }

  useEffect(() => {
    document.addEventListener('keydown', escFunction, false);

    return () => {
      document.removeEventListener('keydown', escFunction, false);
    };
  }, [escFunction]);

  return (
    <div className="removeModal__backdrop" onClick={() => setShowModal(false)}>
      <div
        className={`removeModal ${showModal ? 'show' : ''}`}
        onClick={(e) => {
          // do not close modal if anything inside modal content is clicked
          e.stopPropagation(); }}>
        <p className="removeModal__text">{t('cart.remove_the_product_for_sure?')}</p>
        <Button className="Button Button--primary" onClick={handleRemoveFromCart}>{t('cart.remove')}</Button>
        <div className="CartPopup__linethrough">
          <p><span>{t('cart.or')}</span></p>
        </div>
        <Button className="Button Button--ghost Button--primary" onClick={() => setShowModal(false)}>{t('cart.back')}</Button>
      </div>
    </div>
  );
};

export default RemoveProductModal;
